/* B&A Parts Brand Finder: a single search entry for model/part lookup, plus instant brand filtering. */
(function () {
  'use strict';
  function mount(section) {
    if (section.dataset.baPartsReady) return;
    section.dataset.baPartsReady = 'true';
    const form = section.querySelector('[data-ba-parts-search-form]');
    const input = section.querySelector('[data-ba-parts-search-input]');
    const brands = Array.from(section.querySelectorAll('[data-ba-parts-brand]'));
    const counter = section.querySelector('[data-ba-parts-brand-count]');
    const hint = section.querySelector('[data-ba-parts-hint]');
    const defaultHint = hint.textContent;
    if (!form || !input || !brands.length) return;
    function update() {
      const query = input.value.trim().toLowerCase();
      const matches = brands.filter(function (brand) { return brand.dataset.baPartsBrand.includes(query); });
      const filterCards = !!query && matches.length > 0;
      brands.forEach(function (brand) { brand.hidden = filterCards && !matches.includes(brand); });
      if (filterCards) {
        counter.textContent = matches.length + (matches.length === 1 ? ' brand found' : ' brands found');
        hint.textContent = 'Select a brand, or press Search to find matching products.';
      } else {
        counter.textContent = '';
        hint.textContent = query ? 'Press Search to look up this model or part number.' : defaultHint;
      }
    }
    form.addEventListener('submit', function (event) {
      const typed = input.value.trim();
      if (!typed) { event.preventDefault(); input.focus(); return; }
      const category = section.dataset.baPartsTerm || 'printhead';
      if (!typed.toLowerCase().includes(category.toLowerCase())) {
        input.value = typed + ' ' + category;
      }
    });
    input.addEventListener('input', update);
    update();
  }
  function initialize(root) { (root || document).querySelectorAll('[data-ba-parts-finder]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  else initialize(document);
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
